import { englishNoSpacesRegex } from '@hilma/netina2all';
import { isDate, isString } from 'class-validator';

import createRules from '../../functions/createRules';

export const addCampaignRules = createRules({
	name: { greaterThan: 2, smallerThan: 52, classValidator: (value: string) => isString(value), required: true, name: i18n => i18n.at.tableTitles.name },
	campaignDate: { required: true, classValidator: (date) => isDate(date) },
	source: { required: true, classValidator: (value: string) => isString(value), regex: englishNoSpacesRegex, greaterThan: 2 },
	medium: { required: true, greaterThan: 2, smallerThan: 52, classValidator: (value: string) => isString(value), regex: englishNoSpacesRegex },
	content: { required: true, greaterThan: 0, smallerThan: 52, classValidator: (value: string) => isString(value), regex: englishNoSpacesRegex },
})